import Config from "../../../config";

export async function checkCategoryCertificateStatus({lang, personId, costCenterId}) {
  try {
    validateRequiredParams({lang, personId, costCenterId})
  
    const params = new URLSearchParams({
      pessoa_id: personId,
      centro_custo_id: costCenterId,
      categoria_centro_custo_princ: 'S'
    });

    const response = await fetch(`${Config.baseURL}api/${lang}/center-cost-person/category-certificate-status?${params}`);

    if (!response.ok) {
      throw new Error(`Erro ao buscar dados de expiredCategoryCertificate: ${response.statusText}`);
    }

    const expiredCategoryCertificate = await response.json();

    return expiredCategoryCertificate && expiredCategoryCertificate.data
      ? expiredCategoryCertificate.data
      : {};
  } catch (error) {
    return {
      data: null,
      error,
    };
  }
}

function validateRequiredParams(params) {
  const missing = Object.entries(params)
    .filter(([_, value]) => {
      if (value === undefined || value === null) {
        return true;
      }
      if (typeof value === "string" && value.trim() === "") {
        return true;
      }
      if (value && typeof value === "object" && ("size" in value)) {
        return value.size === 0;
      }  
      return false;
    })
    .map(([key]) => key);

  if (missing.length) {
    throw new Error(`Parâmetros obrigatórios ausentes: ${missing.join(", ")}`);
  }
}